import { Pipe, PipeTransform } from '@angular/core';
import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';
import { TypescriptTypeToColumnTypeConverter } from '../helpers/typescript-to-column-type-converter.helper';

@Pipe({
  name: 'tsTypeToColumnType',
})
export class TsTypeToColumnTypePipe implements PipeTransform {
  transform(value: string | TypescriptTypeEnum): ReturnType<typeof TypescriptTypeToColumnTypeConverter> {
    return TypescriptTypeToColumnTypeConverter(value);
  }
}
